import React from "react";
import { useHistory } from "react-router-dom";
import Community from "../../community/CommunityCard";
import Event from "../../event/EventCard";
import UserCard from "../../../components/user/UserCard";
import Announcement from "../../secretariat/announcement/AnnouncementDashboard";
import CategoryComponent from "../../../components/CategoryComponent";
import "./dashboard.css";
import BottomNavBar from "../../../components/libs/BottomNavBar";
import EmptyListComponent from "../../../components/EmptyListComponent";
import { Loading } from "../../../utils/helpers/constants";
import CommunityPulseLoader from "../../community/CommunityPulseLoader";
import EventPulseLoader from "../../event/EventPulseLoader";
import UserCardPulse from "../../../components/user/UserCardPulse";
import AnnouncementPulse from "../../secretariat/announcement/AnnouncementPulse";

export default function MobileViewDashboard({
  announcements,
  communities,
  people,
  events,
  announcementLoading,
  communityLoading,
  peopleLoading,
  eventListLoading,
}) {
  const history = useHistory();

  const handleEventView = () => {
    history.push("/dashboard/user/events");
  };

  const handleCommunityView = () => {
    history.push("/dashboard/user/community");
  };

  const handleAnnouncementView = () => {
    history.push("/dashboard/user/announcements");
  };

  const handlePeopleView = () => {
    history.push("/dashboard/user/people");
  };

  const communityLoadState = communityLoading === Loading.FETCHING;
  const peopleLoadState = peopleLoading === Loading.FETCHING;
  const eventLoadState = eventListLoading === Loading.FETCHING;
  const announcementLoadState = announcementLoading === Loading.FETCHING;
  const pulseList = [1, 2, 3, 4, 5];

  return (
    <div>
      <div className="flex justify-center">
        <div className="App-height p-0 md:w-1/3 w-screen rounded-md md:mt-0 mx-5 md:bg-gray-50">
          <div className="">
            <div className="App-heigh pb-20">
              <div className="relative w-full h-48 md:h-72 bg-green-800">
                <h3 className="absolute text-2xl text-green-800 top-20 left-5 dash_header md:mt-20 ">
                  Discover
                  <div className="dash_sub_header">
                    Get updates about LUAA and other members
                  </div>
                </h3>
              </div>
              <div className="py-5 px-2">
                <div>
                  <CategoryComponent
                    name={"News & Announcements"}
                    func={() => handleAnnouncementView()}
                  />
                  {announcementLoadState ? (
                    <AnnouncementPulse imageHeight={"h-24"} />
                  ) : (
                    <>
                      {announcements.length === 0 ? (
                        <EmptyListComponent
                          text={"No created announcement"}
                          size={30}
                          height={"h-28"}
                        />
                      ) : (
                        <div className="flex justify-start gap-2 overflow-auto mt-3">
                          <Announcement
                            latestAnnouncement={announcements[0]}
                            link={`/announcement/${announcements[0].id}`}
                            imageHeight={"h-48"}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="my-5">
                  <CategoryComponent
                    name={"Communities"}
                    func={() => handleCommunityView()}
                  />
                  {communityLoadState ? (
                    <div className="flex justify-start gap-2 overflow-auto mt-3 h-48">
                      {pulseList.map((index) => {
                        return (
                          <CommunityPulseLoader
                            key={index}
                            textEllipse={"single_line"}
                            imageHeight={"h-24"}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <>
                      {communities.length === 0 ? (
                        <EmptyListComponent
                          text={"No created communities"}
                          size={30}
                          height={"h-36"}
                        />
                      ) : (
                        <div className="flex justify-start gap-2 overflow-auto mt-3">
                          {communities.map((community, index) => {
                            return (
                              <Community
                                key={index}
                                community={community}
                                textEllipse={"single_line"}
                                imageHeight={"h-24"}
                              />
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="my-5">
                  <CategoryComponent
                    name={"People you might know"}
                    func={() => handlePeopleView()}
                  />
                  {peopleLoadState ? (
                    <div className="flex justify-start gap-2 overflow-auto mt-3 h-20">
                      {pulseList.map((index) => {
                        return (
                          <UserCardPulse
                            key={index}
                            textEllipse={"single_line"}
                            imageHeight={"h-24"}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <>
                      {people.length === 0 ? (
                        <EmptyListComponent
                          text={"No available data"}
                          size={20}
                          height={"h-20"}
                        />
                      ) : (
                        <div className="flex justify-start gap-2 overflow-auto mt-3 h-20">
                          {people.map((uc, index) => {
                            return <UserCard key={index} user={uc} />;
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="my-5">
                  <CategoryComponent
                    name={"Events"}
                    func={() => handleEventView()}
                  />
                  {eventLoadState ? (
                    <div className="flex justify-start gap-2 overflow-auto mt-3 h-48">
                      {pulseList.map((index) => {
                        return (
                          <EventPulseLoader
                            key={index}
                            textEllipse={"single_line"}
                            imageHeight={"h-24"}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <>
                      {events.length === 0 ? (
                        <EmptyListComponent
                          text={"No created events"}
                          size={30}
                          height={"h-36"}
                        />
                      ) : (
                        <div className="flex justify-start gap-2 overflow-auto mt-3">
                          {events.map((event) => {
                            return (
                              <Event
                                key={event.id}
                                event={event}
                                textEllipse={"single_line"}
                                imageHeight={"h-24"}
                              />
                            );
                          })}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BottomNavBar />
      </div>
    </div>
  );
}
